import {OrderStatus} from "@shared/enum/orderStatus";

export const URL_ORDER_LIST = '/api/v1/mvp/order/';
export const buildUrlOrderListWithStatus = (status: OrderStatus) => `${URL_ORDER_LIST}?status=${status.toLowerCase()}`;
export const buildUrlUpdateOrderStatus = (id: any) => `/api/v1/mvp/order/${id}/`;
